<template>
  <div>
      <v-toolbar color="#000000" dark dense>
      <v-spacer></v-spacer>
      <v-toolbar-items>
          <v-btn class="button_font" flat to="/dashboard">  <v-icon right dark class="pr-2">account_balance</v-icon> Dashboard</v-btn>
          <v-btn class="button_font" flat to="/profile"><v-icon right dark class="pr-2">account_box</v-icon> My Profile</v-btn>
            <v-btn class="button_font" flat @click="openNewSubDialog()"><v-icon right dark class="pr-2">edit</v-icon> New Submission</v-btn>
          <v-btn class="button_font" flat @click="logout"><v-icon right dark class="pr-2">exit_to_app</v-icon> Logout</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <SubForm 
        :dialogShow="newSubDiaog" 
        @ondialogClosed="newSubDiaog = false" 
      />
  </div>
</template>

<script>
import SubForm from './SubForm.vue'

export default {
  components: {
    SubForm
  },
  data() {
    return {
      newSubDiaog: false,
    };
  },
  methods:{
    logout(){
      localStorage.clear()
      this.$router.push('/login');
    },
    openNewSubDialog(){
      this.newSubDiaog = true
    },
  }
};
</script>

<style scoped>

.button_font {
  font-weight:bold;
}
</style>